export default __webpack_public_path__ + "static/media/10-color.518fba7f.svg";